/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import Search from "./components/Search";
import Table from "./components/Table";
import { searchLyra } from "../../Api";
import {setTitlePage} from '../../Functions'
import PaginationComponent from "../../components/PaginationComponent/PaginationComponent";

const Visits = () => {
    const [searched, setSearched] = useState(false);
    const [filters, setFilters] = useState<any>({});
    const [state, setState] = useState<any>({
        data: [],
        pages: 0,
        pageIndex: 0,
        pageSize: 10,
        loading: false,
    });

    useEffect(() => {
        setTitlePage("Visitas");
    }, []);

    const handleError = (e: any) => {
        console.error(e);
    };

    const _handleGetData = async (
        pageIndex = 1,
        pageSize = 10,
        newFilters: any = null
    ) => {
        try {
            const params: any = newFilters ? { ...newFilters } : { ...filters };
            params.page = pageIndex;

            if (newFilters) {
                setFilters({ ...newFilters });
            }

            setState((prev: any) => ({ ...prev, loading: true }));
            const data: any = await searchLyra(params);
            const { records, totalPages, page } = data;

            setSearched(true);
            setState({
                data: records || [],
                pages: parseInt(totalPages),
                pageIndex: parseInt(page),
                pageSize,
                loading: false,
            });
        } catch (e: any) {
            setState((prev: any) => ({ ...prev, loading: false }));
            handleError(e);
        }
    };

    return (
        <div>
            <Search
                _handleSearch={(values: any) =>
                    _handleGetData(1, state.pageSize, values)
                }
                _handleError={handleError}
                loading={state.loading}
            />

            <div className="card card-xl-stretch mb-xl-8 mt-5">
                <Table
                    data={state.data}
                    loading={state.loading}
                    searched={searched}
                />

                {state.pages > 1 ? (
                    <div className="my-5">
                        <PaginationComponent
                            totalPages={state.pages}
                            activePage={state.pageIndex}
                            searchData={(page: number) =>
                                _handleGetData(page, state.pageSize)
                            }
                            loading={state.loading}
                        />
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default Visits;
